import ProjectTypes from '../../constants/ProjectTypes';
import withRequiredAuth from '../../HOC/withRequiredAuth';
import withRequiredProduct from '../../HOC/withRequiredProduct';
import Leadership from './Leadership';

export default withRequiredProduct(
  withRequiredAuth(Leadership),
  ProjectTypes.ELEARNING,
);
